import { appActions } from 'apps/builder/store/reducers/entities/app'
export const {
  updateName,
  updateOnSave,
  updateOnPublish,
  updateBuilderVersion,
} = appActions
